var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-btn',{attrs:{"icon":_vm.icon,"count":_vm.favoriteCount,"allow-hover":!_vm.isFavorite,"to":_vm.localePath(_vm.favoriteUrl),"aria-label":_vm.$t('account.favorite')},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }